import { AnalyticsSurfaceCard } from '@repo/ui/components/cards/AnalyticsSurfaceCard';
import { useInsightsSummary } from '../api/useInsightsSummary';
import { CurrentMonthLabel } from '../../../components/analytics/shared/CurrentMonthLabel';
import { palette, ACCENT_HEIGHT_PX } from '@repo/ui/theme';
import { useIsMobile } from '../../../hooks/useIsMobile';

export const InsightsSummaryCard = () => {
  const isMobile = useIsMobile();
  const { data, isLoading } = useInsightsSummary();

  return (
    <AnalyticsSurfaceCard
      className="mx-auto w-full max-w-3xl"
      header={<div className="text-lg font-semibold text-[var(--anl-text)]">Total Sessions</div>}
    >
      <div className={`grid gap-4 ${isMobile ? 'grid-cols-1' : 'grid-cols-3'}`}>
        <StatTile
          label="All Time"
          value={isLoading ? null : (data?.totalSessionsAllTime ?? 0)}
          accentColor={palette.indigo}
        />
        <StatTile
          label={<CurrentMonthLabel />}
          value={isLoading ? null : (data?.totalSessionsLastMonth ?? 0)}
          accentColor={palette.cyan}
        />
        <StatTile
          label="Time Spent"
          value={isLoading ? null : (data?.totalMinutesSpentAllTime ?? '')}
          accentColor={palette.yellow}
          compact={typeof data?.totalMinutesSpentAllTime === 'string'}
        />
      </div>
    </AnalyticsSurfaceCard>
  );
};

const StatTile = ({
  label,
  value,
  accentColor,
  compact = false,
}: {
  label: React.ReactNode;
  value: number | string | null;
  accentColor: string;
  compact?: boolean;
}) => (
  <div className="relative flex flex-col items-center justify-center overflow-hidden rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-4 shadow-sm transition-shadow duration-200 hover:shadow-md">
    <p className="mb-2 text-sm text-[var(--anl-text-muted)]">{label}</p>
    <div className="flex h-12 items-center justify-center">
      {value === null ? (
        <span className="text-3xl font-bold text-[var(--anl-text-muted)]">...</span>
      ) : (
        <span
          className={`font-bold text-[var(--anl-text)] ${compact ? 'whitespace-nowrap text-2xl' : 'text-3xl'}`}
        >
          {value}
        </span>
      )}
    </div>
    <div
      className="absolute bottom-0 left-0 right-0"
      style={{ height: ACCENT_HEIGHT_PX, backgroundColor: accentColor }}
    />
  </div>
);
